import React from 'react';
import ReactApexChart from 'react-apexcharts';

interface GraphLineProps {
  data?: number[];
}

const GraphLine: React.FC<GraphLineProps> = ({ data }) => {
  const options = {
    chart: {
      type: 'line',
      height: 40,
      sparkline: { enabled: true },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    colors: ['#34D399'], // Green line
    tooltip: { enabled: false },
  };

  const series = [
    {
      name: 'Value',
      data: data || [0, 0, 0, 0, 0, 0, 0], // Fallback to zeros if no data
    },
  ];

  return (
    <div className="w-24 h-10">
      <ReactApexChart options={options} series={series} type="line" height={40} />
    </div>
  );
};

export default GraphLine;